/**
 *
 * Chat
 *
 */
import React, { useState, useEffect, useCallback, useRef, useContext, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { withRouter, generatePath } from 'react-router-dom';
import { compose } from 'redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import * as inboxSelectors from './selectors';
import * as inboxActions from './actions';
import {
  makeSelectNetworkStatus,
  makeSelectUserPermissions,
} from 'ui/containers/ProjectDetailsPage/selectors';
import { CONVERSATION_LIST_TYPES } from './constants';
import reducer from './reducer';
import saga from './saga';
import routeTemplates from 'common/route-templates';
import { fieldNames } from './model';
import Pusher from 'pusher-js';
import localStorageTemplates from 'common/local-storage-templates';
import { CHAT_CONSTANT, PUSHER_EVENT_TYPES } from './constants';
import { useConfig } from 'config.js';
import { CHAT } from 'common/strings';
import trimInsentJson from 'utils/trimInsentJson';
import queryString from 'query-string';
import cloneDeep from 'lodash/cloneDeep';
import { checkGroupPermission, isWriteAble } from 'utils/checkPermission';
import { readToken } from 'utils/readToken';
import {
  LoaderContainer,
  ChatSection,
  ChatInputSection,
  EmptyContent,
  ChatContainer,
  ConversationListContainer,
  ChatComponent,
  ChatAndABVContainer,
  ChatDetails,
  ABVContainer,
} from './styled';
import { Text } from 'common/styles';
import illustrationConfig from 'styles/illustrations';
import { OSContext } from 'ui/containers/Providers/OSProvider';
import PageLoader from 'ui/components/Loaders/PageLoader';

const ConversationList = lazy(() => import('./ConversationList/ConversationList'));
const ConversationDetail = lazy(() => import('./ConversationDetail'));
const EditorField = lazy(() => import('./EditorField'));
const ABV = lazy(() => import('./ABV'));

export const Chat = props => {
  useInjectReducer({ key: 'chat', reducer });
  useInjectSaga({ key: 'chat', saga });

  const {
    loading,
    getInboxDetailStart,
    getConversationDetailStart,
    startBookMeeting,
    sender,
    getTeamMembersStart,
    pusherChannels,
    sendConversationMessagesStart,
    agentsList,
    agentsLoading,
    getConversationMembersStart,
    readConversationStart,
    updateConversationStatusStart,
    updateInboxDataStart,
    changeCurrentConversationStart,
    conversationListVisitors,
    getConversationFromParamsStart,
    currentConversation,
    getConversationListStart,
    participants,
    addToConversationListStart,
    removeFromConversationListStart,
    handleSendingMessagePusher,
    networkStatus,
    isUpdateConversationList,
    connectedApps,
    getCannedMessagesStart,
    saveCannedMessageStart,
    deleteCannedMessageStart,
    setEditorHasContentStart,
    sendMessageStart,
    visitor,
    userPermissions,
    conversationDetailDetails,
    updateConversationDetailsStart,
    setCustomFilterStart,
    customFilter,
    getConnectedAppsStart,
    conversationsRead,
    updateConversationsReadStart,
    updateConversationsReadSuccess,
    updateSelectedFiltersStart,
    logoutUserStart,
    openVisitorBlockModal,
    isVisitorBlocked,
    getTagsStart,
    tags,
    isHighlightsSetup,
    isHighlightsFieldsLoading,
    highlightsFieldsData,
    highlightsPopup,
    subscriptions,
    integrations,
    highlightsTemplates,
    getSubscriptionDetailsStart,
    getHighlightsFieldsStart,
    getHighlightsTemplatesStart,
    highlightsBuilderData,
    updateHighlightsBuilder,
    updateHighlightsBuilderStart,
    highlightsMenu,
    highlightsSelectedFieldsCount,
    updateSelectedFieldsCount,
    isHighlightsBuilderLoading,
    isHighlightsInitialSetup,
    conversationListFilters,
    updateConversationListFilters,
    attachments,
    getAttachmentsStart,
    updateAttachments,
    uploadProgress,
    updateUploadProgressStart,
  } = props;
  const { config } = useConfig();
  const { REACT_APP_PUSHER_CLUSTER, REACT_APP_PUSHER_TOKEN } = config || {};
  const inboxPermission = userPermissions && userPermissions.inbox;
  const currentConversationId = currentConversation?.id;
  const conversationType = currentConversation?.botConv
    ? CONVERSATION_LIST_TYPES.BOT
    : CONVERSATION_LIST_TYPES.NON_BOT;
  const visitorId = currentConversation?.user?.id;
  const currentVisitorName = currentConversation?.user?.name;

  const pusher = useRef();
  const pusherChannelsRef = useRef();
  const isPusherChannelsSubscribed = useRef(false);
  const prevNetworkStatus = useRef('online');
  const shouldScrollToLastMessage = useRef({
    scroll: true,
  });

  const [initialValues] = useState({
    [fieldNames.chat]: '',
  });
  const [chatListFilter, setChatListFilter] = useState({
    0: {
      conversationType: '',
      visitorActivity: '',
      visitorTags: [],
    },
    1: {
      conversationType: '',
      visitorActivity: '',
      visitorTags: [],
    },
  });
  const [activeTab, setActiveTab] = useState();
  const [updateConversationsList, setUpdateConversationsList] = useState(false);
  const [pageTitle, setPageTitle] = useState('Chat');
  const [messageToSendToPusher, setMessageToSendToPusher] = useState();
  const { activeOS } = useContext(OSContext);
  const isChatOnly = queryString.parse(props.location.search)['chat_only'] === 'true';
  const isAbvEnabled = queryString.parse(props.location.search).abv === 'true';

  let isEditAble = isChatOnly
    ? true
    : inboxPermission &&
      inboxPermission.permissions &&
      checkGroupPermission(inboxPermission) &&
      isWriteAble(inboxPermission.permissions);

  if (props.location.pathname === '/') {
    //
  }

  useEffect(() => {
    changeCurrentConversationStart({ metadata: { currentConversation: {} } });
    let visitorId = queryString.parse(props.location.search).visitorId;
    const { subEntityId } = queryString.parse(props.location.search);
    let { conversationId } = props.match.params;
    try {
      if (!visitorId || typeof visitorId !== 'string') {
        conversationId = subEntityId && JSON.parse(subEntityId).channelId;
        visitorId = subEntityId && JSON.parse(subEntityId).visitorId;
      }
    } catch (e) {}

    if (conversationId && isChatOnly) {
      getConversationFromParamsStart({
        metadata: {
          conversationId: conversationId,
          ...(visitorId && { visitorId }),
        },
      });
    }
    getInboxDetailStart({ metadata: { activeTab } });
    getTeamMembersStart();
    getConnectedAppsStart();
    getTagsStart();
    getSubscriptionDetailsStart();
    getHighlightsTemplatesStart();
    setChatListFilter(conversationListFilters);

    return () => {
      setCustomFilterStart({ data: {} });
      removeAllSubscriptionAndBindingInPusher();
      changeCurrentConversationStart({ metadata: { currentConversation: {} } });
      updateConversationsReadStart();
      updateSelectedFiltersStart();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      networkStatus === 'online' &&
      prevNetworkStatus.current === 'offline' &&
      currentConversation.id &&
      currentConversation.user
    ) {
      prevNetworkStatus.current = networkStatus;
      setTimeout(() => {
        subscribeToChannels({ callApi: true });
      }, 5000);
    } else {
      prevNetworkStatus.current = networkStatus;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkStatus]);

  useEffect(() => {
    if (pusherChannels && pusherChannels.length > 0 && !isPusherChannelsSubscribed.current) {
      pusherChannelsRef.current = pusherChannels;
      isPusherChannelsSubscribed.current = true;
      subscribeToChannels();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pusherChannels]);

  useEffect(() => {
    if (updateConversationsList) {
      getConversationsList();
      setUpdateConversationsList(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateConversationsList]);

  useEffect(() => {
    if (isUpdateConversationList.status) {
      if (
        isUpdateConversationList.type === PUSHER_EVENT_TYPES.CONVERSATION_MEMBER_JOIN ||
        isUpdateConversationList.type === PUSHER_EVENT_TYPES.CONVERSATION_MEMBER_LEAVE
      ) {
        if (
          chatListFilter?.[activeTab]?.conversationType === CHAT_CONSTANT.STATUS.MY ||
          activeTab === 1
        ) {
          setUpdateConversationsList(true);
        }
      } else {
        setUpdateConversationsList(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateConversationList]);

  const removeAllSubscriptionAndBindingInPusher = () => {
    if (pusher.current) {
      if (pusherChannels && pusherChannels.length) {
        pusherChannels.forEach(channel => {
          if (pusher.current.channel(channel.id)) {
            pusher.current.channel(channel.id).unbind();
            pusher.current.unsubscribe(channel.id);
          }
        });
      }
      pusher.current.disconnect();
    }
  };

  const subscribeToChannels = data => {
    removeAllSubscriptionAndBindingInPusher();
    if (pusherChannelsRef.current && pusherChannelsRef.current[0]) {
      let pusherAuth = pusherChannelsRef.current[0].auth;
      if (pusherAuth.charAt(0) === '/') pusherAuth = pusherAuth.substr(1);

      pusher.current = createPusherObject();
      pusherChannelsRef.current.forEach((channel, index) => {
        let tempChannel = pusher.current.subscribe(channel.id);
        tempChannel.bind('insent-inbox-event', handlePusherUpdates);

        if (index === 0) {
          tempChannel.bind('pusher:subscription_succeeded', function() {
            if (data && data.callApi) {
              getInboxDetailStart({ metadata: { activeTab } });
              getConversationDetailStart({
                metadata: {
                  checkSendingMessages,
                },
              });
            }
          });
          tempChannel.bind('pusher:subscription_error', function(status) {
            setTimeout(() => {
              subscribeToChannels();
            }, 2000);
          });
        }
      });
    }
  };

  useEffect(() => {
    if (currentConversation && currentConversation.id) {
      getConversationDetailStart({ metadata: {} });
      const { id: conversationId, botConv, unread } = currentConversation;
      if (unread && !conversationsRead[conversationId]) {
        const conversationType = botConv
          ? CONVERSATION_LIST_TYPES.BOT
          : CONVERSATION_LIST_TYPES.NON_BOT;
        const metadata = { conversationId, conversationType };
        const clonedConversationRead = cloneDeep(conversationsRead);
        clonedConversationRead[conversationId] = true;
        updateConversationsReadSuccess({
          payload: { conversationsRead: clonedConversationRead },
        });
        readConversationStart({ metadata });
      }
      const pathname = generatePath(routeTemplates.project.inbox.detail, {
        conversationId,
      });
      const searchParams = new URLSearchParams(props.location.search);
      if (
        typeof currentConversation.user.id !== 'undefined' &&
        currentConversation.user.id !== 'undefined'
      ) {
        searchParams.set('visitorId', currentConversation.user.id);
      }
      if (searchParams.get('abv') !== 'false' && !isChatOnly) {
        searchParams.set('abv', true);
      }
      props.history.push(`${pathname}?${searchParams}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentConversation.id]);

  useEffect(() => {
    if (currentConversation.id) {
      getConversationMembersStart({
        metadata: {
          conversationId: currentConversation.id,
          activeTab,
          setActiveTab,
          setUpdateConversationsList,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentConversation.id, currentConversation.status]);
  useEffect(() => {
    if (conversationListVisitors && conversationListVisitors.length > 0) {
      if (!currentConversation || Object.keys(currentConversation).length <= 0) {
        changeCurrentConversationStart({
          metadata: { currentConversation: conversationListVisitors[0] },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationListVisitors]);

  useEffect(() => {
    if (participants && participants.appUsers) {
      if (chatListFilter?.[activeTab]?.conversationType === CHAT_CONSTANT.STATUS.MY) {
        const isAgentMember = participants.appUsers.find(user => user?.id === sender?.userId);
        let type = activeTab === 0 ? CONVERSATION_LIST_TYPES.NON_BOT : CONVERSATION_LIST_TYPES.BOT;
        const metadata = {
          conversation: { ...currentConversation },
          conversationType: type,
        };
        if (isAgentMember) {
          addToConversationListStart({ metadata });
        } else {
          removeFromConversationListStart({ metadata });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [participants]);

  useEffect(() => {
    if (
      customFilter &&
      ((customFilter[activeTab]?.from && customFilter[activeTab]?.to) ||
        customFilter[activeTab]?.clear)
    ) {
      getInboxDetailStart({ metadata: { activeTab } });
      setUpdateConversationsList(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customFilter]);

  useEffect(() => {
    if (messageToSendToPusher) {
      const metadata = {
        newMessages: [{ ...messageToSendToPusher }],
        pusher: pusher.current,
        currentConversation: currentConversation,
      };

      sendConversationMessagesStart({ metadata });
      setMessageToSendToPusher(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageToSendToPusher]);

  useEffect(() => {
    updateConversationListFilters({ data: chatListFilter });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatListFilter]);

  const checkSendingMessages = () => {
    handleSendingMessagePusher({
      metadata: { pusher: pusher.current, from: 'index' },
    });
  };

  const createPusherObject = () => {
    const token = readToken();
    let pusherAuth = pusherChannels[0].auth;
    if (pusherAuth.charAt(0) === '/') pusherAuth = pusherAuth.substr(1);
    const validBaseUrl = window.appDetails.activeBE;
    const pusherToken = REACT_APP_PUSHER_TOKEN;
    return new Pusher(pusherToken, {
      cluster: REACT_APP_PUSHER_CLUSTER,
      authEndpoint: validBaseUrl + pusherAuth,
      auth: {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      },
    });
  };

  const getChatListOptions = data => {
    if (!data) data = { clearFilter: false };
    else if (data.clearFilter === undefined) {
      data.clearFilter = false;
    }
    let options = [],
      type = activeTab === 0 ? CONVERSATION_LIST_TYPES.NON_BOT : CONVERSATION_LIST_TYPES.BOT;
    if (chatListFilter && chatListFilter?.[activeTab]) {
      switch (chatListFilter?.[activeTab]?.conversationType) {
        case CHAT_CONSTANT.STATUS.OPEN:
          options.push('status=open');
          break;
        case CHAT_CONSTANT.STATUS.CLOSE:
          options.push('status=close');
          break;
        case CHAT_CONSTANT.STATUS.PENDING:
          options.push('status=pending');
          break;
        case CHAT_CONSTANT.STATUS.ONLINE:
          options.push('visitorOnline=true');
          break;
        case CHAT_CONSTANT.STATUS.ARCHIVED:
          options.push('archive=true');
          break;
        case CHAT_CONSTANT.STATUS.STARRED:
          options.push('star=true');
          break;
        case CHAT_CONSTANT.STATUS.UNREAD:
          options.push('readStatus=unread');
          break;
        case CHAT_CONSTANT.STATUS.MY:
          type = CONVERSATION_LIST_TYPES.ME;
          options.push('');
          break;
        default:
          break;
      }
      if (chatListFilter?.[activeTab]?.visitorActivity) {
        options.push(
          `visitorActivity=${JSON.stringify([chatListFilter?.[activeTab]?.visitorActivity])}`
        );
      }
      if (
        Array.isArray(chatListFilter?.[activeTab]?.visitorTags) &&
        chatListFilter?.[activeTab]?.visitorTags.length > 0
      ) {
        options.push(`tags=${JSON.stringify(chatListFilter?.[activeTab]?.visitorTags)}`);
      }
    }

    if (
      !data.clearFilter &&
      customFilter &&
      (customFilter[activeTab]?.from || customFilter[activeTab]?.to)
    ) {
      const fromDateTime =
        typeof customFilter[activeTab].from !== 'undefined'
          ? new Date(customFilter[activeTab].from).getTime()
          : customFilter[activeTab].from;
      const toDateTime =
        typeof customFilter[activeTab].to !== 'undefined'
          ? new Date(customFilter[activeTab].to).getTime()
          : customFilter[activeTab].to;

      options.push(
        `fromTime=${Math.round(fromDateTime / 1000)}&toTime=${Math.round(toDateTime / 1000)}`
      );
    }
    options = options.join('&');
    return { options, type };
  };

  const getConversationsList = () => {
    let { options, type } = getChatListOptions();
    getConversationListStart({
      metadata: {
        type: type,
        options: options,
      },
    });
  };

  const startBookAMeeting = () => {
    if (window.confirm(CHAT.ALERTS.BOOK_MEETING_START)) {
      const metadata = {
        conversationId: currentConversation.id,
        visitorId: currentConversation.user.id,
      };

      startBookMeeting({ metadata });
    }
  };

  const switchToUserTab = () => {
    try {
      const conversationUrlParams = new URLSearchParams(props.history.location.search);
      const currentActiveTab = conversationUrlParams.get('tab');

      if (parseInt(currentActiveTab) !== 0) {
        let inboxFilters = JSON.parse(
          localStorage.getItem(localStorageTemplates.inboxSelectedFilter)
        );

        // store applied filters and tab value in local storage
        inboxFilters[0] = CHAT_CONSTANT.STATUS.ALL_CONVERSATIONS;
        inboxFilters.selectedTab = '0';
        localStorage.setItem(
          localStorageTemplates.inboxSelectedFilter,
          JSON.stringify(inboxFilters)
        );

        setActiveTab(0);

        // update selected conversation url params
        conversationUrlParams.set('tab', 0);
        conversationUrlParams.set(
          'status',
          CHAT_CONSTANT.RESOLVE_STATUS[CHAT_CONSTANT.STATUS.ALL_CONVERSATIONS]
        );

        props.history.replace(`${props.history.location.pathname}?${conversationUrlParams}`);

        // set user tab filter to all conversation
        setChatListFilter({
          ...chatListFilter,
          [activeTab]: {
            ...chatListFilter[activeTab],
            conversationType: CHAT_CONSTANT.STATUS.ALL_CONVERSATIONS,
          },
        });

        getConversationListStart({
          metadata: {
            type: CONVERSATION_LIST_TYPES.NON_BOT,
            options: '',
          },
        });
      }
    } catch (err) {
      // do nothing
    }
  };

  const handlePusherUpdates = useCallback(
    data => {
      if (data && data.eventType) {
        const metadata = {
          data,
          switchToUserTab,
        };
        updateInboxDataStart({ metadata });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentConversation]
  );

  const getModifiedMessage = messageItem => {
    if (!messageItem) {
      return;
    }
    let message = messageItem.text || '';
    if (message && messageItem.mentions && messageItem.mentions.length > 0) {
      let agentLists = message.match(/<user:[^>]*>/g);
      for (let i in agentLists) {
        if (agentLists[i].includes(messageItem.mentions[i].id)) {
          message = message.replace(
            agentLists[i],
            `<a href="#" target="_blank">@${messageItem.mentions[i].name}</a>`
          );
        }
      }
    }

    if (messageItem.link) {
      message = `<a href=${messageItem.link.url} target="_blank">${messageItem.link.title} - ${messageItem.link.subtitle}</a>`;
    }

    return message;
  };

  const updateConversationStatuses = ({ status }) => {
    const { id: conversationId, botConv } = currentConversation;
    const conversationType = botConv
      ? CONVERSATION_LIST_TYPES.BOT
      : CONVERSATION_LIST_TYPES.NON_BOT;
    const metadata = { conversationId, conversationType };
    updateConversationStatusStart({
      payload: { status },
      metadata,
    });
  };
  const messagesEndRef = useRef(null);

  const scrollToLastMessage = () => {
    if (messagesEndRef && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView(false);
    }
  };

  const handleSubmit = async values => {
    if (values.feedback) {
      const message = {
        img: sender?.img || null,
        lead: false,
        name: sender?.name,
        id: currentConversation.id,
        feedback: { id: `app-${sender?.userId}-${Date.now()}` },
        time: Math.round(Date.now() / 1000),
        userId: sender?.userId,
        visitorId: currentConversation.user.id,
      };
      shouldScrollToLastMessage.current.scroll = true;
      setMessageToSendToPusher({ ...message });
      if (conversationDetailDetails && conversationDetailDetails.initiateFeedback) {
        updateConversationDetailsStart();
      }
    } else if (values.chat) {
      if (!values.chat || !values.chat.content || values.chat.content.length <= 0) {
        return;
      }
      let chat = trimInsentJson(values.chat);
      const message = {
        img: sender?.img || null,
        lead: false,
        name: sender?.name,
        id: currentConversation.id,
        text: chat,
        time: Math.round(Date.now() / 1000),
        userId: sender?.userId,
        visitorId: currentConversation.user.id,
        ...(values.cannedMessage && { cannedMessage: values.cannedMessage }),
      };
      shouldScrollToLastMessage.current.scroll = true;
      setMessageToSendToPusher({ ...message });
      if (values.callbacks) {
        values.callbacks.setSendingMessage(false);
      }
    } else if (values.attachments) {
      const message = {
        img: sender.img || null,
        lead: false,
        name: sender.name,
        id: currentConversation.id,
        attachments: values.attachments.files,
        assemblyUrl: values.attachments.assemblyUrl,
        time: Math.round(Date.now() / 1000),
        userId: sender.userId,
        visitorId: currentConversation.user.id,
      };
      shouldScrollToLastMessage.current.scroll = true;
      setMessageToSendToPusher({ ...message });
    } else if (values.gif) {
      const message = {
        img: sender.img || null,
        lead: false,
        name: sender.name,
        id: currentConversation.id,
        gif: values.gif,
        time: Math.round(Date.now() / 1000),
        userId: sender.userId,
        visitorId: currentConversation.user.id,
      };
      shouldScrollToLastMessage.current.scroll = true;
      setMessageToSendToPusher({ ...message });
    }
  };

  return (
    <div>
      <Helmet>
        <title>ZoomInfo Chat | Inbox</title>
        <meta name="description" content="Inbox" />
      </Helmet>
      <div>
        {loading ? (
          <LoaderContainer>
            <div className="zoomloader">
              <div className="zoomloaderImg"></div>
            </div>
          </LoaderContainer>
        ) : (
          <ChatContainer className="d-flex">
            <ConversationListContainer>
              <Suspense fallback={<PageLoader size={'small'} />}>
                <ConversationList
                  {...props}
                  currentConversation={currentConversation}
                  setPageTitle={setPageTitle}
                  getModifiedMessage={getModifiedMessage}
                  customFilter={customFilter}
                  setCustomFilter={setCustomFilterStart}
                  chatListFilter={chatListFilter}
                  setChatListFilter={setChatListFilter}
                  getChatListOptions={getChatListOptions}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setUpdateConversationsList={setUpdateConversationsList}
                  sender={sender}
                />
              </Suspense>
            </ConversationListContainer>
            <ChatComponent>
              <ChatAndABVContainer className="d-flex">
                <ChatDetails>
                  {currentConversation && currentConversation.id ? (
                    <ChatSection>
                      <Suspense fallback={<PageLoader size={'small'} />}>
                        <ConversationDetail
                          {...props}
                          isEditAble={isEditAble}
                          isChatOnly={isChatOnly}
                          isAbvEnabled={isAbvEnabled}
                          currentConversation={currentConversation}
                          getModifiedMessage={getModifiedMessage}
                          chatListFilter={chatListFilter}
                          updateConversationStatuses={updateConversationStatuses}
                          messagesEndRef={messagesEndRef}
                          scrollToLastMessage={scrollToLastMessage}
                          visitor={visitor}
                          shouldScrollToLastMessage={shouldScrollToLastMessage}
                          openVisitorBlockModal={openVisitorBlockModal}
                          isVisitorBlocked={isVisitorBlocked}
                          uploadProgress={uploadProgress}
                          currentConversationId={currentConversationId}
                        />
                      </Suspense>
                      {isEditAble && (
                        <ChatInputSection>
                          <Suspense fallback={<PageLoader size={'small'} />}>
                            <EditorField
                              placeholder={`Reply to ${(currentConversation &&
                                currentConversation.user.name) ||
                                'Site visitor'}...`}
                              currentConversation={currentConversation}
                              agents={agentsList}
                              agentsLoading={agentsLoading}
                              handleSubmit={handleSubmit}
                              initialValues={initialValues}
                              conversationDetailDetails={conversationDetailDetails}
                              connectedApps={connectedApps}
                              saveCannedMessageStart={saveCannedMessageStart}
                              deleteCannedMessageStart={deleteCannedMessageStart}
                              setEditorHasContentStart={setEditorHasContentStart}
                              getCannedMessagesStart={getCannedMessagesStart}
                              sendMessageStart={sendMessageStart}
                              updateAttachments={updateAttachments}
                              isVisitorBlocked={isVisitorBlocked}
                              currentConversationId={currentConversationId}
                              conversationType={conversationType}
                              updateUploadProgressStart={updateUploadProgressStart}
                            />
                          </Suspense>
                        </ChatInputSection>
                      )}
                    </ChatSection>
                  ) : (
                    <EmptyContent>
                      <img
                        src={illustrationConfig.emptyState[activeOS]}
                        alt="no conversation selected"
                        height="146px"
                        width="330px"
                      />
                      <Text fontSize={18} fontWeight={500} lineHeight={24} margin={'24px 0 0'}>
                        No conversation yet
                      </Text>
                      <Text color={'#6D7D8F'} margin={'12px 0 0'}>
                        Don't worry, you will get a notification when someone initiates a
                        conversation.
                      </Text>
                    </EmptyContent>
                  )}
                </ChatDetails>
                <ABVContainer>
                  <Suspense fallback={<PageLoader size={'small'} />}>
                    <ABV
                      currentVisitorId={visitorId}
                      currentConversationId={currentConversationId}
                      isInsideDozi={false}
                      isInsideMSTeams={window.appDetails.isInsideMSTeams}
                      isDoziCustomer={window.appDetails.isDoziCustomer}
                      showLockScreen={
                        (!window.appDetails.isInsideMSTeams || !window.appDetails.isDoziCustomer) &&
                        window.appDetails.isZIDashboard
                      }
                      isConversationSelected={currentConversation && currentConversation.id}
                      isEditAble={isEditAble}
                      isChatOnly={isChatOnly}
                      logoutUserStart={logoutUserStart}
                      openVisitorBlockModal={openVisitorBlockModal}
                      tags={tags}
                      isHighlightsSetup={isHighlightsSetup}
                      isHighlightsFieldsLoading={isHighlightsFieldsLoading}
                      highlightsFieldsData={highlightsFieldsData}
                      highlightsBuilderData={highlightsBuilderData}
                      updateHighlightsBuilder={updateHighlightsBuilder}
                      updateHighlightsBuilderStart={updateHighlightsBuilderStart}
                      highlightsPopup={highlightsPopup}
                      subscriptions={subscriptions}
                      integrations={integrations}
                      highlightsTemplates={highlightsTemplates}
                      highlightsMenu={highlightsMenu}
                      highlightsSelectedFieldsCount={highlightsSelectedFieldsCount}
                      updateSelectedFieldsCount={updateSelectedFieldsCount}
                      getHighlightsFieldsStart={getHighlightsFieldsStart}
                      isHighlightsBuilderLoading={isHighlightsBuilderLoading}
                      isHighlightsInitialSetup={isHighlightsInitialSetup}
                      currentVisitorName={currentVisitorName}
                      attachments={attachments}
                      getAttachmentsStart={getAttachmentsStart}
                    />
                  </Suspense>
                </ABVContainer>
              </ChatAndABVContainer>
            </ChatComponent>
          </ChatContainer>
        )}
      </div>
    </div>
  );
};
Chat.propTypes = {
  loading: PropTypes.bool,
  conversationListVisitors: PropTypes.array,
  sender: PropTypes.object,
  conversationListLoading: PropTypes.bool,
  conversationListFiltering: PropTypes.bool,
  conversationDetailMessages: PropTypes.array,
  conversationDetailDetails: PropTypes.object,
  conversationDetailConversationId: PropTypes.string,
  conversationDetailLoading: PropTypes.bool,
  conversationListBot: PropTypes.array,
  statistics: PropTypes.object,
  agentsList: PropTypes.array,
  agentsLoading: PropTypes.bool,
  addingNewMember: PropTypes.bool,
  userStatus: PropTypes.bool,
  newConversationLoading: PropTypes.bool,
  connectedApps: PropTypes.arrayOf(PropTypes.string),
  getInboxDetailStart: PropTypes.func,
  getConversationListStart: PropTypes.func,
  getConversationDetailStart: PropTypes.func,
  getTeamMembersStart: PropTypes.func,
  sendConversationMessagesStart: PropTypes.func,
  startBookMeeting: PropTypes.func,
  getConversationMembersStart: PropTypes.func,
  setArchiveStarConvrsationStart: PropTypes.func,
  addNewMemberConversationStart: PropTypes.func,
  removeMemberConversationStart: PropTypes.func,
  readConversationStart: PropTypes.func,
  updateConversationStatusStart: PropTypes.func,
  updateInboxDataStart: PropTypes.func,
  changeCurrentConversationStart: PropTypes.func,
  getUserStatusStart: PropTypes.func,
  updateUserStatusStart: PropTypes.func,
  closeSelectedConversationStart: PropTypes.func,
  getConnectedAppsStart: PropTypes.func,
  conversationsRead: PropTypes.object,
  updateConversationsReadStart: PropTypes.func,
  updateConversationsReadSuccess: PropTypes.func,
  updateSelectedFiltersStart: PropTypes.func,
  openVisitorBlockModal: PropTypes.func,
  isVisitorBlocked: PropTypes.bool,
  getTagsStart: PropTypes.func,
  tags: PropTypes.array,
  isHighlightsSetup: PropTypes.object,
  isHighlightsFieldsLoading: PropTypes.bool,
  highlightsFieldsData: PropTypes.array,
  highlightsPopup: PropTypes.object,
  highlightsBuilderData: PropTypes.array,
  getHighlightsFieldsStart: PropTypes.func,
  getHighlightsTemplatesStart: PropTypes.func,
  updateHighlightsBuilderStart: PropTypes.func,
  updateHighlightsBuilder: PropTypes.func,
  getSubscriptionDetailsStart: PropTypes.func,
  subscriptions: PropTypes.object,
  integrations: PropTypes.object,
  highlightsTemplates: PropTypes.array,
  highlightsMenu: PropTypes.array,
  highlightsSelectedFieldsCount: PropTypes.object,
  updateSelectedFieldsCount: PropTypes.func,
  isHighlightsBuilderLoading: PropTypes.bool,
  isHighlightsInitialSetup: PropTypes.bool,
  conversationListFilters: PropTypes.object,
  attachments: PropTypes.object,
  getAttachmentsStart: PropTypes.func,
  updateAttachments: PropTypes.func,
  uploadProgress: PropTypes.number,
  updateUploadProgressStart: PropTypes.func,
};
export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    loading: inboxSelectors.makeSelectLoading(),
    conversationListVisitors: inboxSelectors.makeSelectConversationListVisitors(),
    pusherChannels: inboxSelectors.makeSelectInboxPusherChannels(),
    sender: inboxSelectors.makeSelectInboxSender(),
    conversationListLoading: inboxSelectors.makeSelectConversationListLoading(),
    conversationListFiltering: inboxSelectors.makeSelectConversationListFiltering(),
    conversationDetailMessages: inboxSelectors.makeSelectConversationDetailMessages(),
    conversationDetailDetails: inboxSelectors.makeSelectConversationDetailDetails(),
    conversationDetailConversationId: inboxSelectors.makeSelectConversationDetailConversationId(),
    conversationDetailLoading: inboxSelectors.makeSelectConversationDetailLoading(),
    conversationDetailLastMessagePos: inboxSelectors.makeSelectConversationDetailLastMessagePos(),
    conversationListBot: inboxSelectors.makeSelectConversationListBot(),
    visitorListNext: inboxSelectors.makeSelectConversationListVisitorNext(),
    botListNext: inboxSelectors.makeSelectConversationListBotNext(),
    statistics: inboxSelectors.makeSelectInboxStatistics(),
    agentsList: inboxSelectors.makeSelectTeamAgents(),
    agentsLoading: inboxSelectors.makeSelectTeamAgentsLoading(),
    participants: inboxSelectors.makeSelectConversationParticipants(),
    addingNewMember: inboxSelectors.makeSelectAddingNewMembers(),
    newConversationLoading: inboxSelectors.makeSelectNewConversationLoading(),
    currentConversation: inboxSelectors.makeSelectCurrentConversation(),
    sendingMessages: inboxSelectors.makeSelectSendingMessages(),
    networkStatus: makeSelectNetworkStatus(),
    lastReadTime: inboxSelectors.makeSelectReadTime(),
    lastDeliveredTime: inboxSelectors.makeSelectDeliveredTime(),
    isUpdateConversationList: inboxSelectors.makeSelectIsUpdateConversationList(),
    visitor: inboxSelectors.makeSelectVisitor(),
    customFilter: inboxSelectors.makeSelectCustomFilter(),
    userPermissions: makeSelectUserPermissions(),
    connectedApps: inboxSelectors.makeSelectConnectedApps(),
    conversationsRead: inboxSelectors.makeSelectConversationsRead(),
    selectedFilters: inboxSelectors.makeSelectSelectedFilters(),
    isVisitorBlocked: inboxSelectors.makeSelectIsVisitorBlocked(),
    tags: inboxSelectors.makeSelectTags(),
    isHighlightsSetup: inboxSelectors.makeSelectIsHighlightsSetup(),
    isHighlightsFieldsLoading: inboxSelectors.makeSelectIsHighlightsFieldsLoading(),
    highlightsFieldsData: inboxSelectors.makeSelectHighlightsFieldsData(),
    highlightsBuilderData: inboxSelectors.makeSelectHighlightsBuilderData(),
    highlightsPopup: inboxSelectors.makeSelectHighlightsPopup(),
    subscriptions: inboxSelectors.makeSelectSubscriptions(),
    integrations: inboxSelectors.makeSelectIntegrations(),
    highlightsTemplates: inboxSelectors.makeSelectHighlightsTemplate(),
    highlightsMenu: inboxSelectors.makeSelectHighlightsMenu(),
    highlightsSelectedFieldsCount: inboxSelectors.makeSelectHighlightsSelectedFieldsCount(),
    isHighlightsBuilderLoading: inboxSelectors.makeSelectIsHighlightsBuilderLoading(),
    isHighlightsInitialSetup: inboxSelectors.makeSelectIsHighlightsInitialSetup(),
    conversationListFilters: inboxSelectors.makeSelectConversationListFilters(),
    attachments: inboxSelectors.makeSelectAttachments(),
    uploadProgress: inboxSelectors.makeSelectUploadProgress(),
  });
};
export const mapDispatchToProps = {
  setCustomFilterStart: inboxActions.setCustomFilter,
  getInboxDetailStart: inboxActions.getInboxDetail.start,
  getConversationListStart: inboxActions.getConversationList.start,
  getConversationDetailStart: inboxActions.getConversationDetail.start,
  getTeamMembersStart: inboxActions.getTeamMembers.start,
  sendConversationMessagesStart: inboxActions.sendConversationMessages.start,
  startBookMeeting: inboxActions.startBookMeeting.start,
  getConversationMembersStart: inboxActions.getConversationMembers.start,
  setArchiveStarConvrsationStart: inboxActions.setArchiveStarConversation.start,
  addNewMemberConversationStart: inboxActions.addNewMemberConversation.start,
  removeMemberConversationStart: inboxActions.removeMemberConversation.start,
  readConversationStart: inboxActions.readConversation.start,
  updateConversationStatusStart: inboxActions.updateConversationStatus.start,
  updateInboxDataStart: inboxActions.updateInboxData,
  changeCurrentConversationStart: inboxActions.changeCurrentConversation,
  getUserStatusStart: inboxActions.getUserStatus.start,
  updateUserStatusStart: inboxActions.updateUserStatus.start,
  closeSelectedConversationStart: inboxActions.closeSelectedConversation.start,
  getConversationFromParamsStart: inboxActions.getConversationFromParams.start,
  setConversationRequestStart: inboxActions.setConversationRequest.start,
  addToConversationListStart: inboxActions.addToConversationList,
  removeFromConversationListStart: inboxActions.removeFromConversationList,
  handleSendingMessagePusher: inboxActions.handleMessageSendingToPusher,
  setArchiveStarConversationStart: inboxActions.setArchiveStarConversation.start,
  logoutUserStart: inboxActions.logoutUser.start,
  pollBackendStart: inboxActions.pollBackend,
  updateConversationDetailsStart: inboxActions.updateConversationDetails,
  getCannedMessagesStart: inboxActions.getCannedMessages.start,
  saveCannedMessageStart: inboxActions.saveCannedMessage.start,
  deleteCannedMessageStart: inboxActions.deleteCannedMessage.start,
  setEditorHasContentStart: inboxActions.setEditorHasContent,
  sendMessageStart: inboxActions.sendMessage,
  getConnectedAppsStart: inboxActions.getConnectedApps.start,
  updateConversationsReadStart: inboxActions.updateConversationsRead.start,
  updateConversationsReadSuccess: inboxActions.updateConversationsRead.success,
  updateSelectedFiltersStart: inboxActions.updateSelectedFilters.start,
  updateSelectedFiltersSuccess: inboxActions.updateSelectedFilters.success,
  openVisitorBlockModal: inboxActions.openVisitorBlockModal,
  getTagsStart: inboxActions.getTags.start,
  getHighlightsFieldsStart: inboxActions.getHighlightsFields.start,
  getHighlightsTemplatesStart: inboxActions.getHighlightsTemplates.start,
  updateHighlightsBuilderStart: inboxActions.saveHighlightsBuilder.start,
  updateHighlightsBuilder: inboxActions.saveHighlightsBuilder.success,
  getSubscriptionDetailsStart: inboxActions.getSubscriptionDetails.start,
  updateSelectedFieldsCount: inboxActions.updateSelectedFieldsCount,
  updateConversationListFilters: inboxActions.updateConversationListFilters,
  getAttachmentsStart: inboxActions.getAttachments.start,
  updateAttachments: inboxActions.updateAttachments,
  updateUploadProgressStart: inboxActions.updateUploadProgress.start,
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withRouter, withConnect)(Chat);
